<template>
    <gz-auth-view-template>
        <!-- <section class="gz-notification__section" slot="above-title" >
        </section> -->
        <GZ-StaticNotification message="Сообщение" slot="above-title"/>
        
        <GZ-PageTitle :title="`Помещение №${this.$route.params.id}`" slot="title"/>        
        
        <section slot="under-title" class="gz-address-info-card__section">
            <AddressCard :isShelter="true"/>
        </section>

        <section slot="under-notification" class="gz-tabs mbottom-40px">
            <router-link 
                :to="`/admin/shelter/${$route.params.id}/schedule`" 
                class="gz-tabs__item"
            >Проверки</router-link>
            <router-link 
                :to="`/admin/shelter/${$route.params.id}/edit`" 
                class="gz-tabs__item"
            >Редактировать</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
import Shelter from '@/components/custom/admin/forms/add-address/Shelter'
import AddressCard from '@/components/custom/admin/views/addresses/AddressCard'

export default {
    name: 'SingleAddressViewShelter',

    components: {
        Shelter,
        AddressCard
    },
    data() {
        return {
            building: {},
            nextCheckupDate: '',
            bid: '',
            profid: '',
            notes: ''
        }
    },
    mounted() {
        this.getShelter(this.$route.params.id)
    },
    methods: {
        getBuilding(id) {
            this.$axios('building/' + id)
                .then(response => {
                    this.building = response.data.data.attributes
                })
                .catch(err => {
                    console.log('Ошибка загрузки данный о здании: ', err)
                })
        },
        getShelter(id) {
            this.$axios('property/' + id)
                .then(response => {
                    this.bid = response.data.data.attributes.bid
                    this.profid = response.data.data.attributes.profid
                    this.nextCheckupDate = response.data.data.attributes.nextCheckupDate
                })
                .then(() => {
                    this.getBuilding(this.bid)
                }) 
                .catch(err => {
                    console.log('Ошибка загрузки данных о помещении: ', err)
                })
        }
    }
}
</script>